import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-fc9d4140"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "update-content"
};
const _hoisted_2 = {
  class: "header-content"
};
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "提示", -1));
const _hoisted_4 = {
  class: "btn-content"
};
const _hoisted_5 = {
  class: "footer-content"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_van_button = _resolveComponent("van-button");
  const _component_van_field = _resolveComponent("van-field");
  const _component_van_divider = _resolveComponent("van-divider");
  const _component_PageNavBackLayoutCpt = _resolveComponent("PageNavBackLayoutCpt");
  return _openBlock(), _createBlock(_component_PageNavBackLayoutCpt, null, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_hoisted_3, _createElementVNode("p", null, " 修改信息需要验证您的预留手机号，我们将向您的手机号" + _toDisplayString($data.mobile) + "发送短信验证码： ", 1)]), _createElementVNode("div", _hoisted_4, [_createVNode(_component_van_field, {
      modelValue: $data.validateCode,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $data.validateCode = $event),
      required: "",
      name: "validateCode",
      label: "验证码",
      placeholder: "验证码",
      rules: [{
        required: true,
        message: '请填写验证码'
      }]
    }, {
      button: _withCtx(() => [_createVNode(_component_van_button, {
        onClick: _withModifiers($options.getCodeClick, ["prevent"]),
        size: "small"
      }, {
        default: _withCtx(() => [_createTextVNode(" 获取验证码 ")]),
        _: 1
      }, 8, ["onClick"])]),
      _: 1
    }, 8, ["modelValue"])]), _createVNode(_component_van_divider), _createElementVNode("div", _hoisted_5, [_createVNode(_component_van_button, {
      plain: "",
      type: "info"
    }, {
      default: _withCtx(() => [_createTextVNode("取消")]),
      _: 1
    }), _createVNode(_component_van_button, {
      plain: "",
      onClick: _withModifiers($options.beginUpdate, ["prevent"]),
      type: "primary"
    }, {
      default: _withCtx(() => [_createTextVNode(" 开始修改 ")]),
      _: 1
    }, 8, ["onClick"])])])]),
    _: 1
  });
}